import { createTheme } from "@mui/material/styles";
import { Transition } from "../components";
import { useMediaQuery, useTheme } from "@mui/material";

const appTheme = createTheme({
  palette: {
    primary: {
      // light: "#007e94",
      main: "#007e94",
      // dark: "#007e94",
    },
    secondary: {
      //   light: "#e2e3ea",
      main: "#e2e3ea",
      //   dark: "#e2e3ea",
    },
  },
  components: {
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          [theme.breakpoints.up("md")]: {
            "&:nth-of-type(odd)": {
              backgroundColor: "#e7e9eb",
            },
            "&:nth-of-type(even)": {
              backgroundColor: "#ffffff",
            },
          },
        }),
      },
    },

    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: "#007e94",
          color: "white",
        },
        data: {
          color: "white",
        },
        sortActive: {
          color: "white",
        },
      },
    },

    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          color: "white !important",
        },
      },
    },

    MUIDataTableFilterList: {
      styleOverrides: {
        chip: {
          marginBottom: "8px",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize !important",
        },
      },
    },

    MuiDialogContent: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          padding: theme.spacing(2),
          [theme.breakpoints.up("sm")]: {
            minWidth: "500px",
            minHeight: "150px",
          },
        }),
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          padding: theme.spacing(1),
        }),
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          marginBottom: theme.spacing(1),
        }),
      },
    },

    MuiOutlinedInput: {
      defaultProps: {
        fullWidth: true,
        size: "small",
      },
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },

    MuiFormControlLabel: {
      styleOverrides: {
        label: ({ ownerState, theme }) => ({
          ...(ownerState.checked && {
            color: theme.palette.primary.main,
            fontWeight: "600",
          }),
        }),
      },
    },

    MuiDialog: {
      defaultProps: {
        maxWidth: "sm",
        keepMounted: true,
        TransitionComponent: Transition,
      },
    },
  },
});

export default appTheme;

export const Breakpoint = () => {
  const theme = useTheme();
  const isMob = useMediaQuery(theme.breakpoints.down("sm"));
  return isMob;
};
